import { Translation } from './../ridango.models';
import { Injectable } from '@angular/core';

@Injectable( {
    providedIn: 'root'
} )
export class DataTransformService {

    constructor() { }


    transformObjectTranslations ( object: any, key: string ): Translation[] {
        let translations: Translation[] = [];
        const fields = Object.keys( object ).filter( k => k.startsWith( key.trim() + '_' ) && k.length === key.trim().length + 3 );
        translations = fields.map( fieldname => {
            const trans = object[ fieldname ];
            const code = fieldname.split( key.trim() + '_' )[ 1 ]; // split from the start leaves empty string as the first element of array
            const translation = new Translation;
            translation.lang = code;
            translation.field = key;
            translation.translation = trans;
            return translation;
        } );
        return translations;
    }

    // when translations are not fieldname based but 'translation_' based, also possible to convert to different key, e.g. product_name => name
    transformObjectTranslations2( object: any, key: string, newKey: string = null ): Translation[] {
        let translations: Translation[] = [];
        const fields = Object.keys( object ).filter( k => k.startsWith( 'translation_' ) );
        translations = fields.map( fieldname => {
            const trans = object[ fieldname ];
            const code = fieldname.split( 'translation_' )[ 1 ]; // split from the start leaves empty string as the first element of array
            const translation = new Translation;
            translation.lang = code;

            if ( newKey ) {
                translation.field = newKey;
            } else {
                translation.field = key;
            }

            translation.translation = trans;
            return translation;
        } );
        return translations;
    }

}
